import React, { useEffect, useRef, useState } from 'react';
import { isIOS } from 'react-device-detect';
import { Container } from './styles';

import { useVisualizer, models } from 'react-audio-viz';

import musicCoer from '../../assets/music.png';
import Spinner from 'components/Spinner';

interface AudioVisualizerProps {
  url: string;
  autoPlay?: boolean;
}

const AudioVisualizer: React.FC<AudioVisualizerProps> = ({
  url,
  autoPlay = true,
}: AudioVisualizerProps) => {
  const [track, setTrack] = useState<HTMLAudioElement>();
  const [loading, setLoading] = useState(true);

  const mediaElementRef = useRef(null);
  const [ReactAudioViz, initializeVisualizer] = useVisualizer(mediaElementRef);

  useEffect(() => {
    const audio = new Audio();

    audio.crossOrigin = 'anonymous';
    audio.src = url;
    setTrack(audio);
    audio.onloadeddata = () => setLoading(false);
  }, [initializeVisualizer, url]);

  return (
    <Container isIOS={isIOS}>
      {loading ? (
        <Spinner width={50} />
      ) : (
        track && (
          <>
            {isIOS && <img src={musicCoer} alt="" />}
            <audio
              controls
              crossOrigin="anonymous"
              autoPlay={autoPlay}
              onPlay={() => (isIOS ? null : initializeVisualizer())}
              ref={mediaElementRef}
              src={track.src}
            />

            {ReactAudioViz && (
              <ReactAudioViz
                model={models.horizontal({
                  darkMode: true,
                  reversed: false,
                  fadeBars: true,
                  scale: 0.5,
                  color: '#07C961',
                  binSize: 1,
                  frequencyRange: [0, 19000],
                })}
              />
            )}
          </>
        )
      )}
    </Container>
  );
};

export default AudioVisualizer;
